import { useEffect, useState } from "react";
import api, { formatTL } from "@/lib/api";
import { Package, ShoppingCart, Users, TrendingUp } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  if (!stats) return <div>Yükleniyor...</div>;

  const cards = [
    { icon: TrendingUp, label: "Toplam Ciro", val: formatTL(stats.total_revenue), color: "bg-emerald-100 text-emerald-700" },
    { icon: ShoppingCart, label: "Sipariş", val: stats.total_orders, color: "bg-[#0077B6]/10 text-[#0077B6]" },
    { icon: Package, label: "Ürün", val: stats.products, color: "bg-amber-100 text-amber-700" },
    { icon: Users, label: "Müşteri", val: stats.customers, color: "bg-violet-100 text-violet-700" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-3xl font-extrabold tracking-tight mb-8">Dashboard</h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {cards.map(({ icon: Icon, label, val, color }) => (
          <div key={label} className="bg-white rounded-2xl border border-slate-100 p-5">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${color} mb-3`}>
              <Icon size={18} />
            </div>
            <div className="text-xs text-slate-500 uppercase tracking-wider font-bold">{label}</div>
            <div className="font-display text-2xl font-extrabold mt-1">{val}</div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 p-6">
        <h2 className="font-display text-xl font-extrabold mb-4">Son Siparişler</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-slate-500 border-b">
              <th className="py-2">No</th><th>Müşteri</th><th>Tutar</th><th>Durum</th><th>Tarih</th>
            </tr></thead>
            <tbody>
              {stats.recent_orders.map((o) => (
                <tr key={o.id} className="border-b last:border-0">
                  <td className="py-3 font-mono">{o.order_no}</td>
                  <td>{o.address?.full_name}</td>
                  <td className="font-semibold">{formatTL(o.total)}</td>
                  <td><span className="text-xs bg-slate-100 px-2 py-0.5 rounded-full">{o.status}</span></td>
                  <td>{new Date(o.created_at).toLocaleDateString("tr-TR")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
